export enum ErrorStoreStatusEnum {
  INVALID_ARGUMENT = 'invalid-argument',
  OUT_OF_RANGE = 'out-of-range',
  INTERNAL = 'internal'
}
